import { Button, Modal } from "react-bootstrap";
import Select from "react-select";
import Swal from "sweetalert2";

import { useContext, useEffect, useState } from "react";

import { FileInput } from "../Inputs/Inputs.tsx";

import karbala from "../../../assets/images/New folder/bargozide ha/Rajebe Karbala pic.png";

import "../koohrokhi.scss";

import AuthenticationContext from "../../../Authentication/AuthenticationContext.ts";

import { BsTrash3 } from "react-icons/bs";
import CreatableSelect from "react-select/creatable";
import sendRequest from "hooks/useAxios.jsx";
import { showSwalError, showSwalSuccess } from "utils/swal.js";
import TrackContext from "context/TracksContext.jsx";
import { last } from "lodash";

export default function BannerManagement({ tags, banners }) {
  const { setUpdateList, updateList } =
    useContext(TrackContext);
  const [showModal, setShowModal] = useState(false);
  const [tagSelect, setTagSelect] = useState();
  const [trackSelect, setTrackSelect] = useState("");
  const [tracks, setTracks] = useState();
  const [data, setData] = useState({ tag: "", track: "", cover: "" });
  const auth = useContext(AuthenticationContext);
  const dataHandler = (object) => {
    setData((prev) => {
      return { ...prev, ...object };
    });
  };
  let optionsTags = [];
  if (tags) {
    optionsTags = tags.map((val) => {
      return { value: val.title, label: val.title, id: val.id };
    });
  }

  let optionsTracks = [];
  if (tracks) {
    optionsTracks = tracks.map((val) => {
      return { value: val.title, label: val.title, id: val.id };
    });
  }

  const handleFileChangeCover = (e) => {
    const selectedFile = e.target.files[0];
    dataHandler({ cover: selectedFile });
  };

  useEffect(() => {
    sendRequest("audio/Find_audios").then((res) => setTracks(res.data));
  }, []);

  const handleCreateOption = (inputValue) => {
    const newOption = {
      value: inputValue.toLowerCase(),
      label: inputValue,
    };
    console.log(tagSelect);
    setTagSelect(newOption);
    console.log("selected", tagSelect);
    // console.log("newOption", newOption);

    sendRequest("audio/Insert_tags", { title: newOption.value }).then((res) => {
      setUpdateList(!updateList);
    });
    // You can also add the new option to your options list
  };
  const onClickHandlerSubmit = () => {
    let d;
    console.log("data", data);
    if (data.tag !== "" && data.track !== "" && data.cover !== "") {
      d = {
        audioId: data.track,
        tagId: data.tag,
        file: data.cover,
      };
    }
    console.log("d", d);
    sendRequest("audio/add_banner", d).then((res) =>
      res.data.status === 1
        ? (showSwalSuccess("بنر با موفقیت اضافه شد."),
          setUpdateList(!updateList),
          setTagSelect(""),
          setTrackSelect(""),
          dataHandler({ cover: "" })
        )
        : res.data.status === -1
          ? showSwalError("ورودی ها را به درستی وارد کنید.")
          : res.data.status === -2 || res.data.status === -3
            ? showSwalError("مشکلی در افزودن بنر وجود دارد، دوباره تلاش کنید.")
            : ""
    );
  };
  useEffect(() => {
    if (optionsTags.length !== 0) {
      dataHandler({ tag: last(optionsTags).id });
    }
  }, [tags]);
  return (
    <>
      {auth.isLogged && (
        <button
          className="btn bg-secondary text-light ms-auto my-2"
          onClick={() => setShowModal(true)}
        >
          مدیریت بنر
        </button>
      )}
      <Modal
        show={showModal}
        onHide={() => setShowModal(false)}
        size="lg"
        fullscreen="lg-down"
        className="banner-management"
      >
        <Modal.Header closeButton>مدیریت بنر</Modal.Header>
        <Modal.Body>
          <div className="d-flex flex-wrap align-items-center">
            <div className="col-sm-4 col-6 px-1">
              <label className="custom-label">انتخاب تگ:</label>
              <CreatableSelect
                options={optionsTags}
                value={tagSelect}
                onChange={(e) => {
                  dataHandler({ tag: e.id });
                  setTagSelect({ label: e.label, value: e.value });
                }}
                onCreateOption={handleCreateOption}
              />
            </div>
            <div className="col-sm-4 col-6 px-1">
              <label className="custom-label">انتخاب ترک:</label>
              <Select
                options={optionsTracks}
                value={trackSelect}
                onChange={(e) => {
                  dataHandler({ track: e.id });
                  setTrackSelect({ label: e.label, value: e.value });
                }}
              />
            </div>
            <div className="col-sm-4 col-12 px-1">
              <FileInput
                id="1"
                label="انتخاب کاور:"
                onChangeFunc={handleFileChangeCover}
              />
            </div>
          </div>
          <div className="d-flex mt-3">
            <Button
              className="btn ms-auto btn-danger px-3"
              onClick={onClickHandlerSubmit}
            >
              ثبت
            </Button>
          </div>
          <hr />
          <h5 className="fw-bold my-2">لیست بنرها</h5>
          <div className="d-flex flex-wrap">
            {banners.length !== 0
              ? banners.map((val) => {
                return (
                  <BannerItem
                    id={val.id}
                    img={`http://ava.tatdemo.ir/${val.pics[0].path}`}
                    tagTitle={val.tags[0].title}
                    trackTitle={
                      val.audios.length !== 0 ? val.audios[0].title : ""
                    }
                    updateList={updateList}
                    setUpdateList={setUpdateList}
                  />
                );
              })
              : ""}
            {/* <BannerItem img={karbala} tagTitle="برگزیده" trackTitle="کربلا" />
            <BannerItem img={karbala} tagTitle="برگزیده" trackTitle="کربلا" />
            <BannerItem img={karbala} tagTitle="برگزیده" trackTitle="کربلا" />
            <BannerItem img={karbala} tagTitle="برگزیده" trackTitle="کربلا" /> */}
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
}
const BannerItem = ({
  id,
  img,
  tagTitle,
  trackTitle,
  updateList,
  setUpdateList,
  ...props
}) => {
  return (
    <div className="d-flex align-items-center col-md-6 col-12 my-1">
      <div
        style={{ width: 8, height: 8, backgroundColor: "black" }}
        className="rounded-pill me-2"
      />
      <img src={img} style={{ width: 70, height: 70, borderRadius: 10 }} />
      <div className="ms-2">
        <div>
          <span style={{ fontWeight: 700 }}>نام تگ:</span>&nbsp;
          {tagTitle}
        </div>
        <div>
          <span style={{ fontWeight: 700 }}>نام ترک:</span>&nbsp;
          {trackTitle}
        </div>
      </div>

      <BsTrash3
        style={{ width: 20, height: 20, cursor: "pointer" }}
        className="ms-auto me-5"
        color="#fe0000"
        onClick={() => {
          Swal.fire({
            title: "آیا از حذف این آیتم مطمئن هستید؟",
            // icon: icon,
            showCancelButton: true,
            confirmButtonColor: "#fe0000",

            confirmButtonText: "حذف",
            cancelButtonText: "انصراف",
          }).then((result) => {
            if (result.isConfirmed) {
              sendRequest("audio/edit_banner", {
                bannerId: id,
                status: -1,
              }).then((res) =>
                res.data.status === 1
                  ? (showSwalSuccess("بنر با موفقیت حذف شد."),
                    setUpdateList(!updateList))
                  : res.data.status === -1
                    ? showSwalError("ورودی ها را به درستی وارد کنید.")
                    : res.data.status === -2 || res.data.status === -3
                      ? showSwalError(
                        "مشکلی در حذف بنر وجود دارد، دوباره تلاش کنید."
                      )
                      : ""
              );
            }
          });
        }}
      />
    </div>
  );
};
